import { fetchApi } from '@/config/axiosSetting';

type licenseType = {
  const: string;
  fa_const: string;
};
type licenseQueryType = {
  id: number;
  license_type: licenseType;
};

export const licenseTypeRequest = (): Promise<licenseQueryType[]> => {
  return fetchApi({
    method: 'GET',
    url: 'selection_item/license_type/wop_list/',
  });
};
